module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-15-24efd2b9bd44a7173f5469f37178059c.png";